import { Modal, ModalTabs, PDFRenderer } from "components";
import {
  useAppLocation,
  useAppSearch,
  useCurrentUser,
} from "_graphql/cache/auth";

import _ from "lodash";
import config from "config";
import { processUrlData } from "utils/url";
import { useState } from "react";

export default function ViewNoteContainer({
  open,
  setOpen,
}: {
  open: boolean;
  setOpen: (val: boolean) => void;
}) {
  const currentUser = useCurrentUser();
  const [orderStatus, setOrderStatus] = useState<string>("note");
  const searchParams = useAppSearch();
  const { params } = useAppLocation();

  const urls = {
    note: `${config.asset.uri}generate_endorsement_closing/${processUrlData({
      offer_participant_id: searchParams?.id || "",
      endorsement_id: params?.endorsement || "",
    })
      }`,
    contract: `${config.asset.uri}contract_changes/${processUrlData({
      offer_endorsement_id: params?.endorsement || "",
      doc_number: "-1",
      type: "Contract",
      emp_id: currentUser?.employee?.employee_id || "",
    })
      }`,
  };

  return (
    <Modal
      open={open}
      setOpen={setOpen}
      hideActions
      size="6xl"
      title="Endorsement Closing Note"
      description="View Endorsement Closing Note"
    >
      <ModalTabs
        tabs={[
          { name: "Endorsement Closing Note", href: "note" },
          { name: "Contract Changes", href: "contract" },
        ]}
        setOrderStatus={setOrderStatus}
        orderStatus={orderStatus}
      />
      <PDFRenderer url={_.get(urls, orderStatus, "note")} />
    </Modal>
  );
}
